export default __webpack_public_path__ + "static/media/home-projection-card-vector.30e0e2ad.svg";